import React from "react";
import axios from "axios";
import { BACKEND_URL } from "../config/Constant";
import api from "../utils/axiosInstance";

const API = "user";



export const getUserDetails = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/userdetails`, null);
      return response;
    } catch (error) {
      return error;
    }
  };

  export const updateOneUser = async (data) => {
    try {
      const response = await api.post(`${BACKEND_URL}/${API}/updateuser`, data);
      return response;
    } catch (error) {
      return error;
    }
  };





  





